import styled from "styled-components";
import { EditableDiv } from "../../../styles";

interface IProps {
    background: string;
    color: string;
    fontSize: string;
    padding: string;
    borderRadius: string;
}

export const ContainerAddToSchedule = styled.div<IProps>`
display: flex ;
align-items: center;
justify-content: center;
.react-add-to-calendar__button{
    background: ${props => props?.background || '#333'} !important;
    color: ${props => props?.color || '#fff'} !important;
    font-size: ${props => props?.fontSize || '18px'} !important;
    padding: ${props => props?.padding || '15px'} !important;
    border-radius: ${props => props?.borderRadius || '10px'} !important;
}
.react-add-to-calendar__dropdown{
    background: ${props => props?.background || '#333'} !important;
    color: ${props => props?.color || '#fff'} !important;
    margin-top: 30px;
    border-radius: 10px;

    li{
        padding: 15px 10px ;
        color: ${props => props?.color || '#fff'}  !important;
transition: 0.5s all;
        &:hover{
            transform: scale(1.05) ;
        }
        a{
            color: ${props => props?.color || '#fff'}  !important;
        }
    }

}

`;